import { App as AntdApp, ConfigProvider } from "antd";
import "antd/dist/reset.css";
import { Navigate, Route, Routes } from "react-router-dom";
import DashboardLayout from "./components/layout/DashboardLayout";
import { useAuthManager } from "./hooks/useAuthManager";
import "./i18n";
import Campaigns from "./pages/Campaigns";
import CampaignsForm from "./pages/CampaignsForm";
import Home from "./pages/Home";
import Insights from "./pages/Insights";
import Magiccode from "./pages/Magiccode";
import MagiccodeForm from "./pages/MagiccodeForm";
import Merchant from "./pages/Merchant";
import MerchantForm from "./pages/MerchantForm";
import Outlets from "./pages/Outlets";
import OutletsForm from "./pages/OutletsForm";
import OverView from "./pages/Overview";
import Settings from "./pages/Settings";
import SettingsAccount from "./pages/SettingsAccount";
import SettingsAccountPass from "./pages/SettingsAccountPass";
import SettingsMembership from "./pages/SettingsMembership";
import SettingsRoles from "./pages/SettingsRoles";
import Shop from "./pages/Shop";
import ShopForm from "./pages/ShopForm";
import Signin from "./pages/Signin";
import StampCard from "./pages/StampCard";
import StampCardForm from "./pages/StampCardForm";
import Loading from "./utils/Loading";

import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import MerchantOrders from "./pages/MerchantOrders";
import NoAccountPage from "./pages/NoAccount";
import Payout from "./pages/Payout";
import Rewards from "./pages/Rewards";
import RewardsForm from "./pages/RewardsForm";

const CallbackPage = () => {
  const { handleRedirectCallback, error } = useAuth0();

  useEffect(() => {
    const handleAuth = async () => {
      try {
        await handleRedirectCallback();
        window.location.replace("/"); // Match working code's redirect
      } catch (err) {
        // console.error("❌ Callback error:", err);
      }
    };
    handleAuth();
  }, [handleRedirectCallback]);

  if (error) {
    return <div>Error: {error.message}</div>;
  }
  return <div>Loading...</div>;
};

function App() {
  const { isLoading, isAuthenticated } = useAuthManager();

  return (
    <div className="App">
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#f11e69",
            colorLinkHover: "#f11e69",
          },
        }}
      >
        <AntdApp>
          {isLoading ? (
            <Loading />
          ) : (
            <Routes>
            <Route
              path="no-account"
              element={
                isAuthenticated ? <NoAccountPage /> : <Navigate to="/signin" />
              }
            />

            <Route
              path="/callback"
              element={isAuthenticated ? <Navigate to="/" /> : <CallbackPage />}
            />
            {/* SignIn page accessible to unauthenticated users */}
            <Route
              path="/signin"
              element={isAuthenticated ? <Navigate to="/" /> : <Signin />}
            />

            {/* Dashboard page with child routes */}
            <Route
              path="/*"
              element={
                isAuthenticated ? (
                  <DashboardLayout />
                ) : (
                  <Navigate to="/signin" />
                )
              }
            >
              <Route path="home" element={<Home />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="campaigns/add" element={<CampaignsForm />} />
              <Route path="campaigns/edit/:id" element={<CampaignsForm />} />
              <Route path="magic-codes" element={<Magiccode />} />
              <Route path="magic-codes/add" element={<MagiccodeForm />} />
              <Route path="shop" element={<Shop />} />
              <Route path="payout" element={<Payout />} />
              <Route path="shop/add" element={<ShopForm />} />
              <Route path="shop/:id/edit" element={<ShopForm />} />
              <Route path="merchant/orders" element={<MerchantOrders />} />
              <Route path="merchant/add" element={<MerchantForm />} />
              <Route path="merchant" element={<Merchant />} />
              <Route path="insights" element={<Insights />} />
              <Route path="rewards" element={<Rewards />} />
              <Route path="rewards/add" element={<RewardsForm />} />
              <Route path="stamp-card" element={<StampCard />} />
              <Route path="stamp-card/add" element={<StampCardForm />} />
              <Route path="outlets" element={<Outlets />} />
              <Route path="outlets/add" element={<OutletsForm />} />
              <Route path="outlets/edit/:outletUrn" element={<OutletsForm />} />
              <Route path="" element={<OverView />} index />
              <Route path="overview" element={<OverView />} />
              <Route path="settings" element={<Settings />} />
              <Route path="settings/account" element={<SettingsAccount />} />
              <Route
                path="settings/account/change-password"
                element={<SettingsAccountPass />}
              />
              <Route path="settings/roles" element={<SettingsRoles />} />
              <Route
                path="settings/membership"
                element={<SettingsMembership />}
              />
            </Route>
            </Routes>
          )}
        </AntdApp>
      </ConfigProvider>
    </div>
  );
}

export default App;
